/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type DataLevel = typeof DataLevel[keyof typeof DataLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DataLevel = {
  National: 'National',
  ZipCodeRegionalGridOperator: 'ZipCodeRegionalGridOperator',
  Province: 'Province',
  Municipality: 'Municipality',
  City: 'City',
  ResRegion: 'ResRegion',
  Address: 'Address',
  ZipCode: 'ZipCode',
  Other: 'Other',
} as const;
